var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InputAutocompleteCpt',{attrs:{"model":_vm.model,"prop":_vm.prop,"lookups":_vm.lookups,"label":_vm.label,"loading":_vm.isLoading || _vm.loading,"lookupTextProp":"text","disabled":_vm.disabled},on:{"change":_vm.changed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }